import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconMute = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M259.666 46.288c-16.146 0-143.103 123.087-143.103 123.087H25.745c-7.51 0-13.556 6.843-13.556 15.342v143.327c0 8.499 6.046 15.341 13.556 15.341h95.516s123.092 117.637 138.405 117.637c18.422 0 33.25-18.854 33.25-42.277V88.568c0-23.423-14.828-42.28-33.25-42.28z",
		fill: "currentColor",
		paintOrder: "stroke fill markers"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M324.88 166.469a15.295 15.295 0 00-10.952 4.562 15.295 15.295 0 00.168 21.631l67.463 66.43-64.178 63.193a15.295 15.295 0 00-.166 21.63 15.295 15.295 0 0021.629.165l64.513-63.523 64.514 63.523a15.295 15.295 0 0021.631-.166 15.295 15.295 0 00-.168-21.629l-64.178-63.193 67.465-66.43a15.295 15.295 0 00.166-21.63 15.295 15.295 0 00-10.935-4.563 15.295 15.295 0 00-10.694 4.396l-67.8 66.762-67.8-66.762a15.295 15.295 0 00-10.677-4.396z",
		fontWeight: 400,
		fontFamily: "sans-serif",
		overflow: "visible",
		fill: "currentColor"
	})]
});
export { SvgIconMute as ReactComponent };
